module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.ba5cde21.ttf";